// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97167b0e","80":"fc0ac416","236":"7dc0492d","243":"45fd867d","310":"b690eccf","385":"055a8c84","411":"b7abaaab","529":"07d20a10","623":"ae857522","665":"15eda31c","700":"4f9ce3c3","715":"c4921874","892":"1db78500","995":"c5c03248"}[chunkId] + ".chunk.js";
};